import { store } from "@/store";
import { isLanguageSupported } from "@lang";

export const setPageLanguage = (to:any, from:any, next:any) => {
	if(isLanguageSupported(to.query.l)){
		store.commit("localization/setPreferredLanguage", to.query.l);
	}
	next();
};